import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { GoldParticles } from './GoldParticles';
const TITLE = 'ULTRAGAMER';
const letterVariants = {
  hidden: {
    opacity: 0,
    y: 40,
    rotateX: -90
  },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    rotateX: 0,
    transition: {
      delay: 0.6 + i * 0.08,
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  })
};
export function HeroSection() {
  const totalLetterDelay = 0.6 + TITLE.length * 0.08 + 0.6;
  return <section className="relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden" data-id="element-40">
      {/* Background gradient */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse 80% 50% at 50% 20%, rgba(139,92,246,0.12) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-41" />

      <GoldParticles density={50} speed={0.6} data-id="element-42" />

      <div className="relative z-10 text-center px-4" data-id="element-43">
        {/* Main title with letter stagger */}
        <h1 className="font-heading font-black text-6xl sm:text-7xl md:text-8xl lg:text-9xl mb-6 perspective-[1000px]" data-id="element-44">
          {TITLE.split('').map((letter, i) => <motion.span key={i} custom={i} variants={letterVariants} initial="hidden" animate="visible" className="inline-block text-gradient-gold-purple" style={{
          willChange: 'transform, opacity'
        }} data-id="element-45">
              {letter}
            </motion.span>)}
        </h1>

        {/* Subtitle */}
        <motion.p className="font-body text-lg sm:text-xl md:text-2xl text-ultra-purple-light/80 max-w-2xl mx-auto mb-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: totalLetterDelay,
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-46">
          AI that knows every player before they place a bet.
        </motion.p>

        {/* Tagline */}
        <motion.p className="font-body text-sm md:text-base text-white/30 tracking-wide" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: totalLetterDelay + 0.4,
        duration: 0.8
      }} data-id="element-47">
          Predictive Gaming Intelligence&ensp;•&ensp;Limassol, Cyprus
        </motion.p>
      </div>

      {/* Scroll indicator */}
      <motion.div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: totalLetterDelay + 1,
      duration: 0.6
    }} data-id="element-48">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-49">
          <ChevronDownIcon className="w-6 h-6 text-white/25" data-id="element-50" />
        </motion.div>
      </motion.div>
    </section>;
}